import type { ProductCategory, ProductUnit } from "../types";

export interface CustomerShopSummary {
  _id: string;
  name: string;
  county: string;
  subCounty: string;
  ward: string;
  location: string;
  subLocation: string;
  village: string;
  latitude: number;
  longitude: number;
  description?: string;
  imageUrl?: string;
  isActive: boolean;
}

export interface CustomerProduct {
  _id: string;
  catalogProductId?: string;
  catalogProduct?: {
    _id?: string;
    name?: string;
    description?: string;
    category?: ProductCategory;
    unit?: ProductUnit;
    imageUrls?: string[];
  } | null;
  shopId:
    | CustomerShopSummary
    | string;
  farmerId?: string;
  name: string;
  description?: string;
  price: number;
  quantity: number;
  category: ProductCategory;
  unit: ProductUnit;
  imageUrls?: string[];
  imageUrl?: string;
  isApproved?: boolean;
  createdAt?: string;
}

export interface CustomerCartItem {
  productId: CustomerProduct | string | null;
  quantity: number;
}

export interface CustomerCart {
  _id: string;
  shopId: CustomerShopSummary | string;
  items: CustomerCartItem[];
  createdAt?: string;
  updatedAt?: string;
}

export type CheckoutPaymentMethod = "cash_on_delivery" | "mpesa";

export interface CustomerOrderItem {
  _id?: string;
  productId?:
    | {
        _id?: string;
        name?: string;
        price?: number;
        unit?: ProductUnit;
      }
    | string
    | null;
  name?: string;
  price?: number;
  quantity?: number;
}

export interface CustomerOrder {
  _id: string;
  shopId?: CustomerShopSummary | string;
  status: "pending" | "accepted" | "fulfilled" | "cancelled";
  statusMessage?: string;
  totalAmount: number;
  paymentMethod?: CheckoutPaymentMethod;
  paymentStatus?: "pending" | "paid" | "failed";
  deliveryLocation: string;
  phone: string;
  createdAt?: string;
  items?: CustomerOrderItem[];
}

export interface MarketplaceResponse {
  shops: CustomerShopSummary[];
  products: CustomerProduct[];
}

export function isPopulatedShop(
  shop: CustomerProduct["shopId"] | undefined,
): shop is CustomerShopSummary {
  return !!shop && typeof shop === "object" && "_id" in shop;
}

export function isPopulatedCartProduct(
  productId: CustomerCartItem["productId"],
): productId is CustomerProduct {
  return !!productId && typeof productId === "object" && "_id" in productId;
}

export function getProductImages(product: CustomerProduct): string[] {
  if (product.imageUrls?.length) return product.imageUrls;
  return product.imageUrl ? [product.imageUrl] : [];
}

export interface AddToCartDto {
  productId: string;
  quantity: number;
}

export interface UpdateCartItemDto {
  quantity: number;
}

export interface CheckoutDto {
  phone: string;
  deliveryLocation: string;
  paymentMethod: CheckoutPaymentMethod;
}
